<button type="button" class="vpm-close" aria-label="Close" (click)="activeModal.dismiss('close')">
	<mat-icon>close</mat-icon>
</button>

<div class="vpm-body">

	<div *ngIf="loading" class="vpm-loading">
		<svg class="spinner" width="32px" height="32px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
			<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
		</svg>
		<span class="vpm-loading__text">Loading vendor…</span>
	</div>

	<div *ngIf="loadError && !loading" class="alert alert-warning m-3" role="alert">
		<mat-icon style="vertical-align:middle;margin-right:6px;">warning</mat-icon>
		Could not load vendor data.
	</div>

	<app-vendor-brand-payout-entry
		*ngIf="vendorData && !loading"
		[vendor]="vendorData"
		[payoutRow]="payoutRow"
		[suggestedAmount]="suggestedAmount"
		(posted)="onPaymentPosted()"
		(cancelled)="activeModal.dismiss('cancel')"
	></app-vendor-brand-payout-entry>

</div>
